export default {"src":"/_next/static/media/qes-circle.9e844212.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};